export class AddTilingWorkflow {
  static readonly type = '[WorkflowState] AddTiling';
}

export class RemoveTilingWorkflow {
  static readonly type = '[WorkflowState] RemoveTiling';
}
